import styled from 'styled-components'

import { AppBuilder } from '@/components/Icons'
import ImagePreview from '@/components/ImagePreview/ImagePreview'
import { Row } from '@/components/StyledComponents'
import { Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'

const StyledRow = styled.span`
  && {
    display: inline-flex;
    justify-content: flex-start;
    margin-bottom: 3px;
    margin-top: 3px;
    margin-left: 5px;
    align-items: center;
    border-radius: 4px;
    font-size: 12px;
    height: 11px;

    p {
      margin: 0;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`

const StyledIcon = styled.div`
  position: absolute;
  height: 20px;
  width: 20px;
  margin-right: 5px;
  svg {
    height: 20px;
    width: 20px;
    margin-right: 5px;
  }
`

const StyledImg = styled(ImagePreview)`
  position: absolute;
  height: 20px;
  width: 20px;
  margin-right: 5px;
`

const TitleStepLabel = styled.p`
  && {
    font-size: 11px;
    font-style: italic;
    margin: 0 5px;
    padding-left: 30px;
    padding-right: 25px;
    color: #747474;
  }
`

const VariableTypeLabel = styled.p`
  && {
    font-size: 11px;
    font-style: italic;
    padding-left: 5px;
    margin-left: auto;
    color: #747474;
  }
`

const ExampleLabel = styled(VariableTypeLabel)`
  && {
    padding-left: 30px;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

const StepLabel = styled.p`
  && {
    font-size: 11px;
    font-style: italic;
    margin: 0 5px;
    color: #747474;
  }
`
const StyledLabel = styled.label`
  font-size: 0.8rem;
  margin: 0 5px;
  padding-left: 25px;
  padding-right: 25px;
  text-overflow: ellipsis;
  white-space: nowrap;
`
type AutoCompleteVariableSelectedLabelProps = {
  variable: Variable
  showStepLabel?: boolean
}

type AutoCompleteAddedStringLabelProps = {
  value: string
}

const renderOptionIcon = (variable: Variable) => {
  return typeof variable.icon === 'string' ? (
    // @ts-expect-error
    <StyledImg src={variable.icon} fallbackImage={AppBuilder} useLoadingImage={false} />
  ) : (
    <StyledIcon> {variable.icon} </StyledIcon>
  )
}

export const AutoCompleteAddedStringLabel = ({ value }: AutoCompleteAddedStringLabelProps) => (
  <StyledRow>
    <div style={{ display: 'inline-flex' }}>
      <label>{value}</label>
    </div>
  </StyledRow>
)
AutoCompleteAddedStringLabel.displayName = 'AutoCompleteAddedStringLabel'

export const AutoCompleteAddedOption = ({ value }: AutoCompleteAddedStringLabelProps) => (
  <StyledRow style={{ width: '100%' }}>
    <div style={{ width: '100%' }}>
      <StyledLabel>{value}</StyledLabel>
      <Row style={{ justifyContent: 'space-between' }}>
        <TitleStepLabel>{value}</TitleStepLabel>
      </Row>
    </div>
  </StyledRow>
)
AutoCompleteAddedOption.displayName = 'AutoCompleteAddedOption'

export const AutoCompleteVariableLabel = ({
  variable,
  showStepLabel = true
}: AutoCompleteVariableSelectedLabelProps) => (
  <StyledRow>
    {renderOptionIcon(variable)}
    <div style={{ display: 'inline-flex' }}>
      {showStepLabel ? (
        <>
          <StyledLabel style={{ paddingRight: '0' }}>{`${variable.displayName} - `}</StyledLabel>
          <StepLabel>{variable.stepLabel}</StepLabel>
        </>
      ) : (
        <StyledLabel style={{ paddingRight: '0' }}>{variable.displayName}</StyledLabel>
      )}
    </div>
  </StyledRow>
)

AutoCompleteVariableLabel.displayName = 'AutoCompleteVariableSelectedLabel'

export const AutoCompleteVariableOption = ({ variable }: AutoCompleteVariableSelectedLabelProps) => (
  <StyledRow style={{ width: '100%' }}>
    {renderOptionIcon(variable)}
    <div style={{ width: '100%' }}>
      <StyledLabel>{variable.displayName}</StyledLabel>
      <Row style={{ justifyContent: 'space-between' }}>
        <TitleStepLabel>{variable.name}</TitleStepLabel>
        <VariableTypeLabel>{variable.type}</VariableTypeLabel>
      </Row>
      <Row>
        <ExampleLabel>{variable.example?.toString()}</ExampleLabel>
      </Row>
    </div>
  </StyledRow>
)
AutoCompleteVariableOption.displayName = 'AutoCompleteVariableOption'
